module.exports = __webpack_public_path__ + "2f29c8ebaeb667b14d5a00f50d5a93ed.png";